module.exports = __webpack_public_path__ + "img/500px-dark.f75a8ab6.svg";